<template>
<div id="provider" v-if="provider.id">
  <h2>
    Provider {{ provider.title }}
  </h2>

  <provider-nav
    :providerId="providerId"
  />

  <table class="table">
    <tr>
      <td>
        Title
      </td>
      <td>
        {{ provider.title }}
      </td>
    </tr>
    <tr>
      <td>
        Description
      </td>
      <td>
        {{ provider.description || 'n/a' }}
      </td>
    </tr>
    <tr>
      <td>
        Featured Authors
      </td>
      <td>
        <div
          class="list-group"
          v-if="provider.authors.length"
        >
          <router-link
            :to="{
              name: 'author',
              params: {
                authorId: author.id
              }
            }"
            v-for="author in provider.authors"
            :key="author.id"
            class="list-group-item list-group-item-action"
          >
            {{ author.name }}
          </router-link>
        </div>
        <p
          v-else
          class="alert alert-info text-center"
        >
          No featured authors
        </p>
      </td>
    </tr>
    <tr>
      <td>
        Associated Newsletter Types
      </td>
      <td>
        <div
          class="list-group"
          v-if="provider.provider_newsletter_types.length"
        >
          <newsletter-type-list-items />
        </div>
        <p
          v-else
          class="alert alert-info text-center"
        >
          No Associated Newsletter Types
        </p>
      </td>
    </tr>
    <tr>
      <td>
        Abbreviated Title
      </td>
      <td>
        {{ provider.short_title || 'n/a' }}
      </td>
    </tr>
    <tr>
      <td>
        Slug
      </td>
      <td>
        {{ provider.url_title }}
      </td>
    </tr>
    <tr>
      <td>
        Frequency
      </td>
      <td>
        {{ frequencyLbl }}
      </td>
    </tr>
    <tr>
      <td>
        Style
      </td>
      <td>
        {{ provider.style }}
      </td>
    </tr>
    <tr>
      <td>
        Puzzles Can Be Purchased?
      </td>
      <td>
        <span
          class="badge badge-sm badge-primary"
        >
          {{ provider.purchasable ? 'Yes' : 'No' }}
        </span>
      </td>
    </tr>
    <tr>
      <td>
        Inactive?
      </td>
      <td>
        <span
          class="badge badge-sm badge-primary"
        >
          {{ provider.inactive ? 'Yes' : 'No' }}
        </span>
      </td>
    </tr>
    <tr>
      <td>
        Visible?
      </td>
      <td>
        <span
          class="badge badge-sm badge-primary"
        >
          {{ provider.public ? 'Yes' : 'No' }}
        </span>
      </td>
    </tr>
    <tr>
      <td>
        Featured?
      </td>
      <td>
        <span
          class="badge badge-sm badge-primary"
        >
          {{ provider.featured ? 'Yes' : 'No' }}
        </span>
      </td>
    </tr>
    <tr>
      <td>
        Can Be Included in Email Digests?
      </td>
      <td>
        <span
          class="badge badge-sm badge-primary"
        >
          {{ provider.digestible ? 'Yes' : 'No' }}
        </span>
      </td>
    </tr>
    <tr>
      <td>
        Created At
      </td>
      <td>
        {{ this.$root.displayDateTimeFmt(provider.created_at) }}
      </td>
    </tr>
    <tr>
      <td>
        Updated At
      </td>
      <td>
        {{ this.$root.displayDateTimeFmt(provider.updated_at) }}
      </td>
    </tr>
  </table>

  <button
    class="btn btn-danger btn-block"
    v-if="provider.inactive"
    v-on:click="activate"
  >
    Activate Provider
  </button>

  <button
    class="btn btn-danger btn-block"
    v-if="!provider.inactive"
    v-on:click="deactivate"
  >
    Deactivate Provider
  </button>
</div>
</template>

<script>
import Spinner from 'vue-simple-spinner'

import NewsletterTypeListItems from '@/components/NewsletterTypeListItems'
import ProviderNav from '@/components/ProviderNav'

import FlashStore from '@/stores/FlashStore'

import { mapState } from 'vuex'

export default {
  components: {
    'newsletter-type-list-items': NewsletterTypeListItems,
    'provider-nav': ProviderNav,
    'state-spinner': Spinner
  },

  computed: mapState({
    base: state => state.base,
    provider: state => state.ProviderModule.provider,

    frequencyLbl () {
      return {
        0: 'Sunday',
        1: 'Monday',
        2: 'Tuesday',
        3: 'Wednesday',
        4: 'Thursday',
        5: 'Friday',
        6: 'Saturday',
        '*': 'Variable'
      }[this.provider.frequency]
    }
  }),

  props: ['providerId'],

  created () {
    this.get()
  },

  methods: {
    get () {
      this.$store.dispatch(
        'ProviderModule/getProvider', this.providerId
      ).catch(this.$root.processErrors)
    },

    activate () {
      this.$store.dispatch(
        `ProviderModule/activateProvider`, this.providerId
      ).then(() => {
        this.inactive = false
        FlashStore.result('This provider has been activated.')
      }).catch(this.$root.processErrors)
    },

    deactivate () {
      this.$store.dispatch(
        `ProviderModule/deactivateProvider`, this.providerId
      ).then(() => {
        this.inactive = true
        FlashStore.result('This provider has been deactivated.')
      }).catch(this.$root.processErrors)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Provider.vue